<WebView url={purchagePageURL("inline-payment")} title="Payment" autoSize />

<script lang="ts">
  import { purchagePageURL } from "../../../../logic/util/LicenseClient";
  import WebView from "../../../Shared/WebView.svelte";
</script>
